import React from 'react';
import GeneralPageLayout from './GeneralPageLayout';

const BackCover = ({
  primaryBrand,
  uuid,
}): JSX.Element => {
  return (
    <GeneralPageLayout
      textColor={'#FFF'}
      backgroundColor={primaryBrand.colors.dark}
      footerText={uuid}
    />
  );
};

export default BackCover;
